import React from "react";
import { processDataProps } from './processProps';
import useApiData from "./useApiData";

/**
 * Receives a list of components and returns a new list with each component
 * wrapped in function that process its string props and replace placeholder
 * keys with the respective value
 */
export default function withDataProps(componentList) {
    const newComponentList = {};
    for (const [key, Component] of Object.entries(componentList)) {
        const WrappedComponent = (props) => {
            const { data, status }  = useApiData();
            const newProps = processDataProps(data, props, status);
            return <Component {...newProps} />;
        }
        newComponentList[key] = WrappedComponent;
        WrappedComponent.mdxType = key;
    }
    return newComponentList;
}